import { useAuth } from "../contexts/AuthContext";

// Public share pages also offer the connector without a Plutus session.
export function useClaudeConnectorEnabled({ allowSignedOut = false }: { allowSignedOut?: boolean } = {}): boolean {
  const { user, isAuthenticated, isLoading } = useAuth();
  return Boolean(!isLoading && (allowSignedOut || (isAuthenticated && user?.id)));
}
